import { Status } from '../../Status'

const statustMap = {
  Ordered: {
    label: 'Ordered',
    variant: 'grey',
  },
  Processing: {
    label: 'Processing',
    variant: 'grey',
  },
  'In production': {
    label: 'In production',
    variant: 'blue-stroke',
  },
  'Proof ready': {
    label: 'Proof ready',
    variant: 'blue',
    iconName: 'schedule',
  },
  Shipped: {
    label: 'Shipped',
    variant: 'green-stroke',
    iconName: 'local_shipping',
  },
  Delivered: {
    label: 'Delivered',
    variant: 'green-stroke',
    iconName: 'done',
  },
  Standard: {
    label: 'Delivered',
    variant: 'green-stroke',
    iconName: 'done',
  },
  Canceled: {
    label: 'Canceled',
    variant: 'red-stroke',
    iconName: 'done',
  },
}

export function OrderStatusLabel(props: { status: string }) {
  const { status } = props
  return (
    <Status
      {...(statustMap[status] || statustMap.Standard)}
      label={statustMap[status]?.label || status}
    />
  )
}
